import { formatDateVi } from '@repo/ui/src/lib/dateStrings';

/** Every `startAt`/`appliedAt` in the app is stored in the house frame — VN
 *  wall-clock as UTC-naive. Formatting it through the browser's local
 *  timezone double-shifts (+7h again): a session at/after 17:00 VN crosses
 *  midnight in UTC and `new Date(iso)` + local getters print the NEXT day.
 *  Slicing the ISO date part and formatting from that instead reads the
 *  frame the value was written in, regardless of the viewer's timezone.
 *
 *  `pattern` picks the display shape:
 *  - 'full'  -> dd/MM/yyyy (formatDateVi)
 *  - 'short' -> dd/MM (no year — payroll's session date column)
 */
export function fmtHouseDate(iso: string, pattern: 'full' | 'short' = 'full'): string {
  const ymd = iso.slice(0, 10);
  if (pattern === 'short') {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
    if (!match) return iso;
    const [, , month, day] = match;
    return `${day}/${month}`;
  }
  return formatDateVi(ymd);
}

/** `appliedAt` is stored in the app's house frame — VN wall-clock as UTC-naive
 *  — like every `startAt`. Formatting it through the browser's local timezone
 *  double-shifts (+7h again) and printed tomorrow's date; slicing the ISO date
 *  and going through `formatDateVi` reads the frame it was written in. */
export function fmtAppliedDate(iso: string): string {
  return fmtHouseDate(iso, 'full');
}
